import * as React from "react";

function SvgComponent(props) {
  return (
    <svg
      viewBox="0 0 41 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <style>{".cls-logo-icon-1{fill:currentColor;}"}</style>
      </defs>
      <path d="M20 0v52.5M2 36l18 17 18.5-17" stroke="#fff" strokeWidth="5" />
    </svg>
  );
}

export default SvgComponent;
